import React, { useState } from "react";
import Context from "./index";
import { create } from "../../Api/AuthApi";
import { Form, message } from "antd";
const AdminLoginProvider = ({ children, ...props }) => {
  const [adminLoginLoader, setAdminLoginLoader] = useState(false);
  const [formAdminLogin] = Form.useForm();
  const [formAdminLoginStepOne] = Form.useForm();
  const [formAdminLoginStepTwo] = Form.useForm();
  const [adLoginStepOneLoader, setAdLoginStepOneLoader] = useState(false);
  const [adLoginStepTwoLoader, setAdLoginStepTwoLoader] = useState(false);
  const [adLoginStep, setAdLoginStep] = useState(0);
  const [otpId, setOtpId] = useState(null);
  const [adminRole, setAdminRole] = useState(null);
  async function adminLogin(data = {}) {
    setAdminLoginLoader(true);
    await create("login.php?action=superadminloginv2", data)
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          localStorage.setItem("nattu_admin_login", true);
          localStorage.setItem("nattu_admin_token", res?.data?.token);
          localStorage.setItem("nattu_admin_name", res?.data?.name);
          localStorage.setItem("nattu_admin_role", res?.data?.role);
          setAdminRole(res?.data?.role);
          window.location.href = "/admin";
          setAdminLoginLoader(false);
        } else {
          message.error(res?.message);
          setAdminLoginLoader(false);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
        setAdminLoginLoader(false);
      });
  }
  async function adminLoginStepOne(data = {}) {
    setAdLoginStepOneLoader(true);
    await create("login.php?action=customerlogin", data)
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          setOtpId(res?.data?.otp_id);
          setAdLoginStep(1);
          setAdLoginStepOneLoader(false);
        } else {
          setOtpId(null);
          formAdminLoginStepOne.resetFields();
          message.error(res?.message);
          setAdLoginStepOneLoader(false);
        }
      })
      .catch((err) => {
        setOtpId(null);
        message.error("Something went wrong");
        setAdLoginStepOneLoader(false);
      });
  }
  async function adminLoginStepTwo(data = {}) {
    setAdLoginStepTwoLoader(true);
    await create("login.php?action=otpverifyv2", {
      otp_id: otpId,
      otp_code: data?.otp_code,
    })
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          // console.log("res?.data?.token", res?.data?.token);
          localStorage.setItem("nattu_admin_login", true);
          localStorage.setItem("nattu_admin_token", res?.data?.token);
          localStorage.setItem("nattu_admin_name", res?.data?.name);
          localStorage.setItem("nattu_admin_role", res?.data?.role);
          setAdminRole(res?.data?.role);
          window.location.href = "/admin";
          setAdLoginStep(0);
          setAdLoginStepTwoLoader(false);
        } else {
          formAdminLoginStepTwo.resetFields();
          message.error("Invalid OTP");
          setAdLoginStepTwoLoader(false);
        }
      })
      .catch((err) => {
        message.error("Invalid OTP");
        setAdLoginStepTwoLoader(false);
      });
  }

  async function adminRoleFetch() {
    await create("banner.php?action=verify_my_role")
      .then((res) => {
        if (res?.status === 200 && res?.success === true) {
          // alert(res?.data?.role);
          localStorage.setItem("nattu_admin_role", res?.data?.role);
          setAdminRole(res?.data?.role);
        }
      })
      .catch((err) => {
        message.error("Something went wrong");
      });
  }
  return (
    <Context.Provider
      value={{
        ...props,
        adminLogin,
        adminLoginLoader,
        setAdminLoginLoader,
        formAdminLogin,
        formAdminLoginStepOne,
        formAdminLoginStepTwo,
        adLoginStepOneLoader,
        setAdLoginStepOneLoader,
        adLoginStepTwoLoader,
        setAdLoginStepTwoLoader,
        adLoginStep,
        setAdLoginStep,
        otpId,
        setOtpId,
        adminLoginStepOne,
        adminLoginStepTwo,
        adminRoleFetch,
        adminRole,
        setAdminRole,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AdminLoginProvider;
